import { render, staticRenderFns } from "./checkRecordDetail.vue?vue&type=template&id=595aa56d&scoped=true&"
import script from "./checkRecordDetail.vue?vue&type=script&lang=js&"
export * from "./checkRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkRecordDetail.vue?vue&type=style&index=0&id=595aa56d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595aa56d",
  null
  
)

export default component.exports